export function formatInt(n: number): string {
  return new Intl.NumberFormat("en-US").format(Math.round(n));
}

export function formatPercent(percent: number): string {
  if (percent <= 0) return "0%";
  if (percent >= 100) return "100%";
  if (percent < 0.1) return `${percent.toFixed(3)}%`;
  if (percent < 10) return `${percent.toFixed(2)}%`;
  return `${percent.toFixed(1)}%`;
}

export function formatPace(n: number): string {
  if (!Number.isFinite(n)) return "—";
  if (n >= 100) return formatInt(n);
  if (n >= 10) return n.toFixed(1);
  return n.toFixed(2);
}

export function formatDay(iso: string): string {
  const raw = iso.slice(0, 10);
  const parts = raw.split("-").map(Number);
  const y = parts[0];
  const m = parts[1];
  const d = parts[2];
  if (y === undefined || m === undefined || d === undefined) return raw;
  const dt = new Date(y, m - 1, d);
  return dt.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function hostOf(url: string): string {
  try {
    return new URL(url).host;
  } catch {
    return url.replace(/^https?:\/\//, "");
  }
}

export function appHref(slug: string, url: string): string {
  if (url) return url;
  return `https://${slug}.over9000.cc`;
}
